module.exports = __webpack_public_path__ + "static/real-time-tracking-1a55779299c8541f475ae2aa7f7244e1.png";